const RETRY_MAX_TIMES = 5;
const RETRY_INTERVAL_MS = 1000;

export function retryFailLoad(
  fn,
  retriesLeft = RETRY_MAX_TIMES,
  interval = RETRY_INTERVAL_MS
) {
  return () =>
    new Promise((resolve, reject) => {
      fn()
        .then(resolve)
        .catch((error) => {
          // This code is boilerplate solution that we don't want to modify
          setTimeout(() => {
            if (retriesLeft === 1) {
              // We're not sure what kind of error comes here, so we just re-throw what comes.
              reject(error);
              return;
            }

            retryFailLoad(fn, retriesLeft - 1, interval)().then(
              resolve,
              reject
            );
          }, interval);
        });
    });
}
